exports = module.exports = require("../../../../../../../shared/rnclient/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.subject-input--input--1U-vf3XE {\n  padding: 3px 0;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n\n.subject-input--inputElement--1EfSec-V {\n  background: white;\n  padding-left: 6px;\n}\n\n.subject-input--input--1U-vf3XE[class~=fluid] {\n  width: 100%;\n}\n\n.subject-input--hint--2bJ_bqi1 {\n  top: 15px;\n  left: 6px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/subject-input.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,oBAAoB;MAChB,YAAY;UACR,QAAQ;CACjB;;AAED;EACE,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,YAAY;CACb;;AAED;EACE,UAAU;EACV,UAAU;CACX","file":"subject-input.css","sourcesContent":["\n.input {\n  padding: 3px 0;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n\n.inputElement {\n  background: white;\n  padding-left: 6px;\n}\n\n.input[class~=fluid] {\n  width: 100%;\n}\n\n.hint {\n  top: 15px;\n  left: 6px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"input": "subject-input--input--1U-vf3XE",
	"inputElement": "subject-input--inputElement--1EfSec-V",
	"hint": "subject-input--hint--2bJ_bqi1"
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!/home/deploy/gamba/shared/rnclient/node_modules/postcss-loader/lib!./src/web/components/themes/subject-input.css
// module id = 2781
// module chunks = 4